import React from 'react';

import withStyles from '@mui/styles/withStyles';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';

// @mui/icons-material
import Close from '@mui/icons-material/Close';

import NewTaskForm from './NewTaskForm';
import NewTaskForm_SingleCategory from './NewTaskForm_SingleCategory';

const localStyles = (theme) => ({
  modalRoot: {
    overflow: 'auto',
    alignItems: 'unset',
    justifyContent: 'unset',
  },
  modal: {
    [theme.breakpoints.up('sm')]: {
      maxWidth: '670px',
      margin: 'auto',
    },
    borderRadius: '6px',
    marginTop: '100px !important',
    overflow: 'visible',
    maxHeight: 'unset',
    position: 'relative',
    height: 'fit-content',
  },
  modalHeader: {
    borderBottom: 'none',
    paddingTop: '24px',
    paddingRight: '24px',
    paddingBottom: '0',
    paddingLeft: '24px',
    minHeight: '16.43px',
  },
  modalCloseButton: {
    // color: grayColor[0],
    marginTop: '-12px',
    WebkitAppearance: 'none',
    padding: '0',
    cursor: 'pointer',
    background: '0 0',
    border: '0',
    fontSize: 'inherit',
    opacity: '.9',
    textShadow: 'none',
    fontWeight: '700',
    lineHeight: '1',
    float: 'right',
  },
  modalClose: {
    width: '16px',
    height: '16px',
  },
  modalTitle: {
    margin: '0',
    lineHeight: '1.42857143',
  },
  modalBody: {
    paddingTop: '6px',
    paddingRight: '24px',
    paddingBottom: '16px',
    paddingLeft: '24px',
    position: 'relative',
    overflow: 'visible',
  },
});

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

/*
Because we had already created the NewTaskForm, we just embedded this component within
our Modal structure.
Call this with
    <NewTaskModal
        show={the condition under which it should show}
        initialSubjectStatus=<'Lead' | 'Prospect' | 'Client' | 'Alum' | 'Referral Company' | 'Referral Contact'>
        initialSubjectId=<some ID>
        subjectIdsNamesAndCategories={[] of {id: n, name: "abc"} objects}
        taskSubjectCategory={<one of: 'inquiry', 'client', 'refCompany', 'refContact', 'multiple'>}
        visibleFirmId={visibleFirmId}  //optional
        closeModalFunc={a function for closing the dialog}
    />
*/

class NewTaskModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: undefined,
    };
  }

  closeUnlessBackdropClick(event, reason, closeModalFunc) {
    if (reason !== 'backdropClick') {
      closeModalFunc(event, reason);
    }
  }

  render() {
    if (this.state.errorMessage) {
      return <h3>{this.state.errorMessage}</h3>;
    }

    const {
      classes,
      show,
      subjectIdsNamesAndCategories,
      taskSubjectCategory,
      initialSubjectStatus,
      initialSubjectId,
      visibleFirmId,
      closeModalFunc,
    } = this.props;

    const useMultiple = taskSubjectCategory === 'multiple';

    return (
      <Dialog
        classes={{
          root: /* classes.center + " " +*/ classes.modalRoot,
          paper: classes.modal,
        }}
        open={!!show}
        TransitionComponent={Transition}
        disableEscapeKeyDown={true}
        onClose={(event, reason) => closeUnlessBackdropClick(event, reason, closeModalFunc)}
      >
        <DialogTitle id="modal-title" className={classes.modalHeader}>
          <IconButton className={classes.modalCloseButton} onClick={closeModalFunc} size="large">
            <Close className={classes.modalClose} />
          </IconButton>
          <h4 className={classes.modalTitle}>Define New Task</h4>
        </DialogTitle>
        <DialogContent id="modal-description" className={classes.modalBody}>
          {useMultiple ? (
            <NewTaskForm
              subjectIdsNamesAndCategories={subjectIdsNamesAndCategories}
              initialSubjectStatus={initialSubjectStatus}
              initialSubjectId={initialSubjectId}
              visibleFirmId={visibleFirmId}
              closeModalFunc={closeModalFunc}
            />
          ) : (
            <NewTaskForm_SingleCategory
              subjectIdsNamesAndCategories={subjectIdsNamesAndCategories}
              subjectCategory={taskSubjectCategory}
              initialSubjectId={initialSubjectId}
              visibleFirmId={visibleFirmId}
              closeModalFunc={closeModalFunc}
            />
          )}
        </DialogContent>
      </Dialog>
    );
  }
}

export default withStyles(localStyles)(NewTaskModal);
